import FormTextBox from "../yoello-lib/modules/dynamicForms/FormComponents/FormTextBox";
import IDynamicFormRow from "../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow";

export default function venueAddressForm(): IDynamicFormRow[] {
  function validatePostcode(postCode: string) {
    const regex = '^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$'
    if (postCode.match(regex)) {
      return true
    }
    return false
  }

  return [
    {
      label: "selectLocation.apartment",
      keyName: "address_number",
      Component: FormTextBox,
      disabled: false,
      gridColumnOptions: {
        formCol: 12
      },
    },
    {
      label: "selectLocation.streetAddress",
      keyName: "address_street",
      Component: FormTextBox,
      disabled: false,
      gridColumnOptions: {
        formCol: 12
      },
      registerOptions:{
        required: true,
      },
    },
    {
      label: "selectLocation.city",
      keyName: "address_city",
      Component: FormTextBox,
      disabled: false,
      gridColumnOptions: {
        formCol: 12
      },
      registerOptions:{
        required: true,
      },
    },
    {
      label: "selectLocation.postcode",
      keyName: "address_postcode",
      Component: FormTextBox,
      disabled: false,
      gridColumnOptions: {
        formCol: 12
      },
      registerOptions:{
        required: true,
        validate: validatePostcode
      },
    },
  ]
}
